export const isDate = (dateString, hms=true) => {
  if(!_.isNil(dateString)) {
    var r=hms?dateString.toString().match(/^(\d{1,4})(-)(\d{1,2})\2(\d{1,2})\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/):dateString.toString().match(/^(\d{1,4})(-)(\d{1,2})\2(\d{1,2})$/); 
    if(r==null) {
        return false;
    }
    var d=new Date(r[1],r[3]-1,r[4]);  
    var num = (d.getFullYear()==r[1]&&(d.getMonth()+1)==r[3]&&d.getDate()==r[4]);
    if(num==0){
        return false
    }
    return true;
  } else {
    return false
  }
}